var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17.4999C9.60948 17.8904 8.97631 17.8904 8.58579 17.4999L0.792892 9.70703C0.402369 9.31651 0.402369 8.68334 0.792892 8.29282L8.58579 0.499923C8.97631 0.109399 9.60948 0.109399 10 0.499924V0.499924C10.3905 0.890449 10.3905 1.52361 10 1.91414L3.91421 7.99992L18 7.99992C18.5523 7.99992 19 8.44764 19 8.99992V8.99992C19 9.55221 18.5523 9.99992 18 9.99992L3.91421 9.99992L10 16.0857C10.3905 16.4762 10.3905 17.1094 10 17.4999V17.4999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.22e179b770a9895ff7120383da3b9893.svg";
export { ForwardRef as ReactComponent };